<template>
  <a class="bg-neutral-350 rounded-action-primary text-foreground px-2.5 py-1 md:px-3 md:py-1.5 font-ui text-ui-md">
    <slot />
  </a>
</template>
